module.exports = __webpack_public_path__ + "img/co.0e50dcfe.svg";